export default __webpack_public_path__ + "static/media/mako.0b76fb89.svg";